/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomerFormattedType, CustomerResponse, JourneyResult } from 'shared/config/types/customerResponse';
import { useContext } from 'react';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import Quote, { mockPayload } from 'shared/api/assurant/quote';
import { isRecoverableQuoteResponseMessage } from 'shared/utils/isRecoverableQuoteResponseMessage';

export const useCustomerJourneyMutationQuery = () => {
	const queryClient = useQueryClient()
	const { setInitialPayloadData } = useContext(FormDataContext);
	return useMutation({
		mutationFn: Quote.getRentersQuote,
		onSuccess: data => {
			const journeyResult: JourneyResult = parse(data.data.journeyResult)
			const quoteRequest = JSON.parse(journeyResult.customer.quoteRequest) as unknown as CustomerResponse;
			queryClient.setQueryData<{campaignId: string}>
			(['campaignId'], { campaignId:  quoteRequest.CampaignId }
			);
			const responseMessage = journeyResult.quote_result.transactionDetails.responseMessage
			if (!journeyResult.quote_result.transactionDetails.workItemId && responseMessage && !isRecoverableQuoteResponseMessage(responseMessage)) {
				throw new Error(responseMessage);
			}
			// Ensure the quote bounds (e.g., personal property min/max/increment) are available to the first page.
			queryClient.setQueryData(['quoteData'], journeyResult.quote_result)
			queryClient.setQueryData<CustomerFormattedType>
			(['applicationFormData'], { ...data.data,
				journeyResult: journeyResult  }
			);
			queryClient.setQueryData<JourneyResult>
			(['journeyData'],
				{
					...journeyResult  }
			);
		},
		onError: error => {
			console.log('Error getting quote', error);
			setInitialPayloadData(mockPayload)
		}
	})
}

export const useCustomerDataUpdateMutationQuery = () => {
	return useMutation({
		mutationFn: Quote.updateRentersQuote,
		onError: error => {
			console.log('something goes wrong', error);
		},
	})
}
export const useJourneyResultFormQuery = () => {
	const client = useQueryClient();
	return client.getQueryData<JourneyResult>(['journeyData']);
}

export const useJourneyResultCampaignIdQuery = () => {
	const client = useQueryClient();
	return client.getQueryData<{ campaignId: string }>(['campaignId']);
}
function parse(str: string): JourneyResult {
	return JSON.parse(str) as unknown as JourneyResult
}
export const useJourneyQuery = () => {
	const client = useQueryClient()
	return client.getQueryData<CustomerFormattedType>(['applicationFormData'])
}
